export default __webpack_public_path__ + "static/media/zantelbanner-min.0115e556.jpeg";